import { ReactNode } from "react";
import "./ControlSection.scss";

type Props = {
  label: string;
  children: ReactNode;
};

const ControlSection: React.FC<Props> = ({ label, children }) => {
  return (
    <div className="control-section">
      <label className="control-section__label">{label}</label>
      <div className="control-section__content">{children}</div>
    </div>
  );
};

export default ControlSection;
